import { render, staticRenderFns } from "./NewSouthWalesForms.vue?vue&type=template&id=24836d48&scoped=true&"
import script from "./NewSouthWalesForms.vue?vue&type=script&lang=ts&"
export * from "./NewSouthWalesForms.vue?vue&type=script&lang=ts&"
import style0 from "./NewSouthWalesForms.vue?vue&type=style&index=0&id=24836d48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24836d48",
  null
  
)

export default component.exports